import { render, staticRenderFns } from "./JwSelectClass.vue?vue&type=template&id=053beeb8"
import script from "./JwSelectClass.vue?vue&type=script&lang=js"
export * from "./JwSelectClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports